import { render, staticRenderFns } from "./mainfooter.vue?vue&type=template&id=610f8a4c&"
import script from "./mainfooter.vue?vue&type=script&defer=true&lang=js&"
export * from "./mainfooter.vue?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports